<template>
  <b-card class="mb-3 site">
    <div v-show="loading" class="text-center">
      <b-spinner
        style="width: 3rem; height: 3rem; margin-top: 2em;"
        label="Loading..."
      />
    </div>

    <div v-show="!loading">
      <div class="row">
        <div class="col text-center mt-3">
          <h3>All done. Do you want to submit?</h3>
          <p>Once you've submitted, you can't go back and edit any answers.</p>
          <p>
            Use the progress bar or the back button to navigate back an amend any answers that you want to before
            submitting.
          </p>
          <b-alert :show="completeError" variant="danger">
            {{ completeError }}
          </b-alert>
        </div>
      </div>

      <hr>

      <div class="row navigation">
        <div class="offset-md-2 col-md-4 mb-2">
          <button class="btn forward btn-secondary"
                  :class="{selected: selectedButton === 'back'}"
                  :disabled="loading"
                  @click="jumpToStage(0)">
            Back to the Start
          </button>
        </div>
        <div class="col-md-4">
          <button class="btn forward btn-primary"
                  :class="{selected: selectedButton === 'submit'}"
                  :disabled="loading"
                  @click="submit()">
            Submit
          </button>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
  import keybindMixin from "../../../utils/keybind"

  export default {
    name: 'EvaluationSubcomponentsSubmission',
    mixins: [keybindMixin],
    props: {
      submit: {type: Function, required: true},
      loading: {type: Boolean, required: true},
      completeError: {validator: prop => typeof prop === 'string' || prop === null, required: true},
      jumpToStage: {type: Function, required: true},
    },
    data: function () {
      return {
        selectedButton: null
      }
    },
    created() {
      this.registerKeydownHandler(['ArrowRight', 'Right', 'ArrowLeft', 'Left'], () => {
        switch(this.selectedButton) {
          case 'submit':
            this.selectedButton = 'back'
            break
          case null:
          case 'back':
            this.selectedButton = 'submit'
            break
        }
      })
      this.registerKeydownHandler(['Enter'], () => {
        switch(this.selectedButton) {
          case 'submit':
            this.submit()
            break
          case 'back':
            this.jumpToStage(0)
            break
        }
      })
    }
  }
</script>

<style scoped lang="scss">

  hr {
    margin: 3em 0;
  }

  button {
    min-height: 4em;
    @media (max-width: 575px) {
      margin-top: 1em;
      width: 90%;
    }
  }

  .navigation {
    text-align: center;

    @media (min-width: 576px) {
      .forward {
        float: right;
      }
      .backward {
        float: left;
      }
    }
  }

  .question-number {
    h3 {
      word-wrap: normal;
    }

    @media (max-width: 575px) {
      text-align: center;
    }
  }
</style>